import { MessageContainer, Severity } from "../Message/MessageContainer";

export type TNotification = {
  id: string;
  title: string;
  error?: unknown;
  details?: string;
  type: "INFO" | "WARN" | "ERROR" | "SUCCESS";
};

type TProps = {
  className?: string;
  showTopN?: number | null;
  notifications: TNotification[];

  dismiss: (id: string) => void;
};

const getMessageSeverityType = (notType: TNotification["type"]): Severity => {
  switch (notType) {
    case "ERROR": {
      return Severity.Error;
    }
    case "WARN": {
      return Severity.Warning;
    }

    case "SUCCESS": {
      return Severity.Success;
    }

    default:
    case "INFO": {
      return Severity.Information;
    }
  }

  return Severity.Information;
};

// const showErrors = false;
// const renderError = (err: unknown) => {
//   if (!err) {
//     return null;
//   }
//   if (typeof err === "string") {
//     return err;
//   }
//   if (typeof err === "object") {
//     let vals: string[] = [];
//     vals.push(`${(err as Record<string, unknown>).message}`);
//     vals.push(`${(err as Record<string, unknown>).stack}`);
//     vals = vals.filter((i) => typeof i === "string").filter(Boolean);
//     if (vals.length) {
//       return vals.join("\n\n");
//     }
//   }
//   return `${err}`;
// };

{
  /* TODO PDN need to have some way of toggling this to actually show errors */
}
// {(showErrors && n.error && <div className="font-mono">{renderError(n.error)}</div>) || null}

export const NotificationsPresentational = (props: TProps) => {
  const notifications =
    props.showTopN && props.showTopN > 0 ? props.notifications.slice(0, props.showTopN) : props.notifications;

  return notifications.length > 0 ? (
    <div className={props.className}>
      {notifications.map((n) => {
        const severity = getMessageSeverityType(n.type);

        return (
          <div key={n.id} className="mb-5">
            <MessageContainer
              key={n.id}
              content={n.details ?? n.title}
              title={n.title}
              severity={severity}
              secondaryAction={() => props.dismiss(n.id)}
              secondaryActionLabel="Dismiss"
            />
          </div>
        );
      })}
    </div>
  ) : (
    <></>
  );
};
